import { render, staticRenderFns } from "./SearchPluginCustom.vue?vue&type=template&id=2919b620&scoped=true"
import script from "./SearchPluginCustom.vue?vue&type=script&lang=ts"
export * from "./SearchPluginCustom.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SearchPluginCustom.vue?vue&type=style&index=0&id=2919b620&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2919b620",
  null
  ,true
)

export default component.exports